export const TipoConsulta = [
    {
        codigo: 1,
        opcion: "CON CONSECUTIVO"
    }, {
        codigo: 2,
        opcion: "CON FECHA INICIAL - FECHA FINAL"
    }];


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/empresas_trasladadas/modelo/TipoConsulta.ts